import React from 'react';
import { cn } from './cn';
import { initials } from './styles';

/**
 * shadcn/ui Avatar: fotoğraf varsa fotoğraf, yoksa baş harfler.
 * Boyut `className` ile veriliyor; verilmezse 32 piksel. (Boyut sınıfı
 * varsayılanın üstüne yazılmıyor — hangi sınıfın kazandığı CSS sırasına
 * kalmasın.)
 */
export const Avatar: React.FC<{ src?: string | null; name: string; className?: string }> = ({ src, name, className }) => (
  <span className={cn('relative flex shrink-0 overflow-hidden rounded-full bg-muted', className ?? 'size-8')}>
    {src ? (
      <img src={src} alt="" className="aspect-square size-full object-cover" />
    ) : (
      <span className="flex size-full items-center justify-center font-semibold text-muted-foreground">
        {initials(name)}
      </span>
    )}
  </span>
);
